export default __webpack_public_path__ + "static/media/academic_cap.c331f471.svg";